// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginLayout_loginContainer__+Aa53","loginHeader":"LoginLayout_loginHeader__DzYFR","loginDescription":"LoginLayout_loginDescription__FX7EU"};